interface FUTURE_VALUE_CALCULATOR_PROPS {
  initialInvestment: number | undefined;
  periodicInvestment: number | undefined;
  rateOfInterest: number | undefined;
  periodOfInvestment: number | undefined;
}

export const FUTURE_VALUE_CALCULATOR_FORMULA = ({
  initialInvestment,
  periodicInvestment,
  rateOfInterest,
  periodOfInvestment,
}: FUTURE_VALUE_CALCULATOR_PROPS) => {
  if (
    !initialInvestment ||
    !periodOfInvestment ||
    !periodicInvestment ||
    !rateOfInterest ||
    Number(initialInvestment) < 0 ||
    Number(periodOfInvestment) < 0 ||
    Number(periodicInvestment) < 0 ||
    Number(rateOfInterest) < 0
  ) {
    return {
      presentInvestmentValue: 0,
      futureInvestmentValue: 0,
      periodicInvestmentValue: 0,
      interestEarned: 0,
    };
  }

  const r = rateOfInterest / 100;
  const n = periodOfInvestment;

  // Future value of the initial investment (lump sum)
  const futureValueLumpSum = initialInvestment * Math.pow(1 + r, n);

  // Future value of periodic investments
  const futureValueAnnuity =
    periodicInvestment * ((Math.pow(1 + r, n) - 1) / r);

  // Total future value
  const futureInvestmentValue =
    Number(futureValueLumpSum) + Number(futureValueAnnuity);

  // Total amount of periodic investments
  const totalPeriodicInvestments = periodicInvestment * n;

  // Present value of all investments
  const presentInvestmentValue =
    Number(initialInvestment) + Number(totalPeriodicInvestments);

  // Interest earned
  const interestEarned = futureInvestmentValue - presentInvestmentValue;

  return {
    presentInvestmentValue: Math.round(initialInvestment),
    futureInvestmentValue: Math.round(futureInvestmentValue),
    periodicInvestmentValue: Math.round(totalPeriodicInvestments),
    interestEarned: Math.round(interestEarned),
  };
};
